import { render, staticRenderFns } from "./paid-order-list.vue?vue&type=template&id=04bd8ea9&"
import script from "./paid-order-list.vue?vue&type=script&lang=js&"
export * from "./paid-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports